import React, { useState } from "react";
import { ExportOutlined, PhoneOutlined } from "@ant-design/icons";
import { Divider, Table, Row, Button, Col } from "antd";
import { STATUS, SecurePassLogType } from "@/utils/enum";
import LogOutreachAttemptPopup from "@/components/SecurePass/LogOutreachAttemptPopup/LogOutreachAttemptPopup";
import useSecurePassLogs from "@/components/SecurePass/useSecurePassLogs";
import useSecurePassOutreachColumns from "./utils/useSecurePassOutreachColumns";

export default function SecurePassOutreachAttemptsTable({ shipmentId }) {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const columns = useSecurePassOutreachColumns();
  const { data, status, refreshData } = useSecurePassLogs(shipmentId, SecurePassLogType.OutreachAttempt);

  return (
    <>
      <Col flex={1}>
        <Row>
          <Divider orientation="left" style={{ marginTop: 0, marginBottom: 0, paddingTop: 16 }}>
            Logged Outreach Attempts
          </Divider>
          <Table
            dataSource={data}
            columns={columns}
            pagination={{
              pageSize: 3,
              showSizeChanger: false,
            }}
            loading={status === STATUS.LOADING}
            style={{ minWidth: "100%" }}
          />
        </Row>
      </Col>

      <Col flex={1}>
        <Row justify="end" align="middle" style={{ paddingTop: 0, paddingBottom: 0 }}>
          <Button
            type="default"
            icon={<ExportOutlined />}
            href={`/admin/secure-pass-logs?page=1&pageSize=10&q=${shipmentId}`}
            target="_blank"
          >
            View All Logs
          </Button>
          <Button
            type="primary"
            icon={<PhoneOutlined />}
            onClick={() => setIsPopupVisible(true)}
            style={{ marginLeft: 5 }}
          >
            Log Attempt
          </Button>
        </Row>
      </Col>

      <LogOutreachAttemptPopup
        visible={isPopupVisible}
        shipmentId={shipmentId}
        onClose={() => setIsPopupVisible(false)}
        onLogSuccess={refreshData}
      />
    </>
  );
}
